// Runs at most `max` async tasks at once; the rest wait in order. Expand all opens up to 50 size
// tables, and the dashboard API has seven DB connections per instance, so the per-product detail
// calls go through this instead of all firing together.
export function createLimiter(max) {
  let active = 0;
  const queue = [];
  const next = () => {
    if (active >= max || queue.length === 0) return;
    active += 1;
    const { task, resolve, reject } = queue.shift();
    Promise.resolve()
      .then(task)
      .then(resolve, reject)
      .finally(() => {
        active -= 1;
        next();
      });
  };
  return (task) =>
    new Promise((resolve, reject) => {
      queue.push({ task, resolve, reject });
      next();
    });
}

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Retries a fetch-returning task while the server answers 503 ("Busy, please try again").
export async function retryBusy(task, { attempts = 3, delayMs = 1500 } = {}) {
  let response = await task();
  for (let i = 1; i < attempts && response && response.status === 503; i += 1) {
    await sleep(delayMs * i);
    response = await task();
  }
  return response;
}
